<template>
    <AppLayout title="Envíos">
        <div class="retiros bg-white">
            <div class="">
                <Toast />

                <div
                    class="flex flex-col lg:flex-row lg:justify-between lg:items-center pt-4 mb-4 mr-6"
                >
                    <Breadcrumb
                        name="Envíos"
                        routeName="envios"
                        page="Mercado Libre"
                    />
                </div>

            </div>
            <!-- filters -->
            <div>
                <!-- navbar -->
                <nav
                    class="bg-white border-gray-200 border-b px-2 sm:px-4 py-2.5 fixed z-30 w-full"
                >
                    <div
                        class="container flex flex-wrap justify-between items-center mx-auto"
                    >
                        <div class="ml-4">
                            <img
                                class="mx-2"
                                src="@assets/images/shared/mercadolibre.png"
                                alt="logo_mercadolibre"
                                width="250" 
                                height="300"
                            />
                        </div>
                        <div class="ml-4">
                            <div class="jumbotron">
                                <h1 class="display-4">Vinculacion realizada con exito!</h1>
                                <p class="lead"></p>
                                <hr class="my-4">
                                <!-- <p>It uses utility classes for typography and spacing to space content out within the larger container.</p> -->
                                <p class="lead">
                                    <!-- <a class="btn btn-primary btn-lg" href="#" role="button">Learn more</a> -->
                                </p>
                            </div>
                        </div>
                        <div class="ml-4">
                        </div>
                    </div>
                </nav>
            </div>
        </div>
    </AppLayout>
</template>

<script>
import { Link } from "@inertiajs/inertia-vue3";
import AppLayout from "@/Layouts/AppLayout.vue";
import CustomFilter from "@/Pages/Envios/components/CustomFilter.vue";
import CustomPaginator from "./components/CustomPaginator.vue";
import TrackingColumn from "./components/TrackingColumn.vue";
import DeleteDialog from "./components/DeleteDialog.vue";
import Breadcrumb from "@/shared/Breadcrumb.vue";
import Button from "@/shared/Button.vue";
import { Icon } from "@vicons/utils";
import {
    ArrowRight,
    Bookmark,
    AngleDoubleRight,
    FileExport,
    Plus,
} from "@vicons/fa";
import { BoxCheckmark24Filled, BookmarkOff24Filled } from "@vicons/fluent";

export default {
    components: {
        Link,
        AppLayout,
        CustomFilter,
        CustomPaginator,
        TrackingColumn,
        DeleteDialog,
        Breadcrumb,
        Icon,
        ArrowRight,
        AngleDoubleRight,
        FileExport,
        Bookmark,
        Button,
        Plus,
        BoxCheckmark24Filled,
        BookmarkOff24Filled 
    }
};
</script>

<style></style>
